import { useParams } from "react-router-dom";
import { useGetUserOrderDetailsQuery } from "src/store/slices/client/client.api";
import GiftcardInstructions from "./components/GiftcardInstructions/GiftcardInstructions";
import GiftcardMainDetails from "./components/GiftcardMainDetails/GiftcardMainDetails";
import GiftcardDetailsSkeleton from "./components/GiftcardDetailsSkeleton/GiftcardDetailsSkeleton";
import { explode } from "src/utility";
import { useTranslation } from "react-i18next";
import NoData from "@Components/NoData/NoData";

export default function GiftcardsDetails() {
  const { id } = useParams();
  const {t, i18n} = useTranslation();
  const { data, isFetching, error } = useGetUserOrderDetailsQuery<{ data: any; isFetching: boolean; error: unknown }>({
    referenceNumber: id,
    lang:i18n.language,
  });

  const { orderedAt, statusEnum, referenceNumber } = explode(data, {});
  const item = data?.orderItems?.[0];
  const {
    name,
    brandName,
    points,
    value,
    redemptionChannel,
    imageUrl,
    termsAndCondition,
    usageInstructions,
    cardCode,
    cardExpireyDate,
    provider,
    cardPin,
  } = explode(item, {});

  const props = {
    orderedAt, cardPin, statusEnum, referenceNumber, name, brandName, points, value,
    redemptionChannel, imageUrl, termsAndCondition, usageInstructions, cardCode,
    cardExpireyDate, provider, isFetching,
  };

  if (isFetching) return <GiftcardDetailsSkeleton />;
  if (error) {
    return (
      <div className="flex w-full flex-1 items-center justify-center">
        <NoData description={t("UserHistory.orderDetails.detailsUnavailable")} className="h-full w-full" />
      </div>
    );
  }

  return (
    <div className="flex gap-3 w-full pb-5 md:p-5 md:flex-row flex-col">
      <div className="flex flex-5">
        <GiftcardMainDetails props={props} />
      </div>
      <div className="flex-2 flex">
        <GiftcardInstructions usageInstructions={usageInstructions} termsAndCondition={termsAndCondition} />
      </div>
    </div>
  );
}
